<div class="modal" *ngIf="visible">
    <div class="modal-content">
        <div class="modal-header">
            <h3>{{ 'Common.Form.language' | translate }}</h3>
            <button class="close-button" (click)="close()">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18M6 6L18 18" stroke="#FFFFFF80" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </button>
        </div>
        <div class="modal-body">
            <div class="language-list">
                <div *ngFor="let lang of languages" class="language-item" [class.active]="currentLang === lang.code"
                    (click)="changeLanguage(lang.code)">
                    <div class="language-info">
                        <span class="name">{{ lang.name }}</span>
                        <span class="native-name">{{ lang.nativeName }}</span>
                    </div>
                    <div class="check-icon" *ngIf="currentLang === lang.code">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0ZM14.707 7.293L9.707 12.293C9.512 12.488 9.256 12.6 8.99 12.6C8.724 12.6 8.468 12.488 8.273 12.293L5.293 9.313C4.902 8.922 4.902 8.29 5.293 7.899C5.684 7.508 6.316 7.508 6.707 7.899L8.99 10.182L13.293 5.879C13.684 5.488 14.316 5.488 14.707 5.879C15.098 6.27 15.098 6.902 14.707 7.293Z"
                                fill="#FF5E5E" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>